// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlayCircle: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="144" height="144" viewBox="0 0 144 144"><defs><circle id="a" cx="62" cy="62" r="62"/></defs><g fill="none" fillRule="evenodd" transform="translate(10 10)"><use xlinkHref="#a" fill="currentColor"/><circle cx="62" cy="62" r="67" stroke="#FFF" strokeOpacity=".3" strokeWidth="10"/><circle cx="62" cy="62" r="61" stroke="currentColor" strokeLinejoin="inherit" strokeWidth="2"/><path fill="#FFF" fillRule="nonzero" d="M83.2539077,57.9762938 C84.6503909,58.8407233 85.5,60.3632974 85.5,62.0037479 C85.5,63.6441999 84.6503909,65.166774 83.2539077,65.942795 L55.1318373,83.2313783 C53.684571,84.2038605 51.8730472,84.2431522 50.3945317,83.4081922 C48.9157225,82.5732322 48,81.0015428 48,79.2923312 L48,44.7151645 C48,43.009883 48.9157225,41.4372103 50.3945317,40.6022503 C51.8730472,39.7682736 53.684571,39.8026519 55.1318373,40.6916405 L83.2539077,57.9762938 Z"/></g></svg>
};

export default React.memo(PlayCircle);
